import React, { useState } from 'react';
import classNames from 'classnames';
import { Button, ClickAwayListener, List, ListItem, ListItemText } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { getLinkProps } from '../../../utils';

import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { muiTheme } from '../../../theme';

const Navbar = ({ user, navigationLinks, dropdownLinks, classes }) => {
  const location = useLocation();
  const currentPage = location.pathname;

  const [open, setOpen] = useState(false);

  const handleDropdownToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavigationLinks = () =>
    getLinksForUser(navigationLinks).map(({ link, title }) => {
      const isCurrentPage = currentPage === link;
      return (
        <Button
          className={classNames(classes.nav, {
            [classes.active]: isCurrentPage,
          })}
          key={title}
          variant="contained"
          component={Link}
          to={link}
          disableElevation
        >
          {title}
        </Button>
      );
    });

  const getLinksForUser = links =>
    links.filter(({ roles = [] }) =>
      roles.length > 0 && user ? user.userTeams.some(value => roles.includes(value)) : true,
    );

  const renderDropdown = () => (
    <List className={classes.dropdown} component="div" aria-label="Navigation Dropdown">
      {getLinksForUser(dropdownLinks.links).map(link => (
        <ListItem key={link.link} button {...getLinkProps(link)} onClick={handleClose}>
          <ListItemText primary={link.title} />
        </ListItem>
      ))}
    </List>
  );

  const renderNavigationDropdown = () => {
    return (
      <ClickAwayListener onClickAway={handleClose}>
        <div>
          <Button
            className={classNames(classes.nav, {
              [classes.open]: open,
            })}
            variant="contained"
            disableElevation
            onClick={handleDropdownToggle}
            endIcon={<KeyboardArrowDownIcon />}
          >
            {dropdownLinks.title}
          </Button>
          {open && renderDropdown()}
        </div>
      </ClickAwayListener>
    );
  };

  return (
    <div className={classes.root} data-testid="header-navbar">
      {navigationLinks && renderNavigationLinks()}
      {dropdownLinks && renderNavigationDropdown()}
    </div>
  );
};

export default withStyles(styles(muiTheme))(Navbar);
